<template>
  <div class="md:w-12/12 flex error_handle_section p-4">
    <div class="error_question mr-6 hide-mobile">
      <i-questmark-404
        filled
        :font-controlled="false"
      />
    </div>
    <div class="error_handler">
      <p>
        {{ $t('404suggestions') }}
      </p>
      <ul>
        <li class="_handle mb-0">
          <i18n-t
            data-i18n="404suggestionVisitStart"
            keypath="404suggestionVisitStart"
          >
            <nuxt-link to="/">
              {{ $t('startPage') }}
            </nuxt-link>
          </i18n-t>
        </li>
        <li
          v-if="!$isSol"
          class="_handle mb-0"
        >
          <i18n-t
            data-i18n="404suggestionBrowseCalendar"
            keypath="404suggestionBrowseCalendar"
          >
            <nuxt-link :to="`${localeURLs.calendar}`">
              {{ $t('calendar') }}
            </nuxt-link>
          </i18n-t>
        </li>
        <li class="_handle mb-0">
          {{ $t('404suggestionSearch') }}
        </li>
        <li class="_handle mb-0">
          {{ $t('404suggestionGetInspired') }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
const { urls: localeURLs } = useLocale()
</script>